import { TFunction } from 'i18next';

const getProgressDuration = (eta: number | null, t: TFunction): string => {
  if (!eta) return '';

  if (eta < 60) {
    return `~${Math.round(eta)} ${t('sec-label')}`;
  }
  return `~${Math.round(Math.floor(eta / 60))} ${t('min-label')}`;
};

export default getProgressDuration;
